import React from 'react';

function Button(props) {
    return <button {...props} />;
}

export default Button;
